import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const ListPatientDiagnosticReportsDocument = gql`
  query ListPatientDiagnosticReports($dateQuery: String!, $subjectId: String!) {
    patient(id: $subjectId) {
      id
      diagnosticReports: diagnosticReportsConnection(
        code: "http://loinc.org|81247-9"
        tag: "http://lifeomic.com/fhir/source|LifeOmic Variant Selection"
        date: $dateQuery
        sort: "-date"
        first: 5
      ) {
        edges {
          node {
            __typename
            code {
              coding {
                system
                code
              }
            }
            effectiveDateTime
            id
            status
            result {
              reference
            }
            extension {
              url
              valueReference {
                reference
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useListPatientDiagnosticReportsQuery__
 *
 * To run a query within a React component, call `useListPatientDiagnosticReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPatientDiagnosticReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPatientDiagnosticReportsQuery({
 *   variables: {
 *      dateQuery: // value for 'dateQuery'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useListPatientDiagnosticReportsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ListPatientDiagnosticReportsQueryResponse,
    ListPatientDiagnosticReportsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    ListPatientDiagnosticReportsQueryResponse,
    ListPatientDiagnosticReportsQueryVariables
  >(ListPatientDiagnosticReportsDocument, baseOptions);
}
export function useListPatientDiagnosticReportsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListPatientDiagnosticReportsQueryResponse,
    ListPatientDiagnosticReportsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    ListPatientDiagnosticReportsQueryResponse,
    ListPatientDiagnosticReportsQueryVariables
  >(ListPatientDiagnosticReportsDocument, baseOptions);
}
export type ListPatientDiagnosticReportsQueryHookResult = ReturnType<
  typeof useListPatientDiagnosticReportsQuery
>;
export type ListPatientDiagnosticReportsLazyQueryHookResult = ReturnType<
  typeof useListPatientDiagnosticReportsLazyQuery
>;
export type ListPatientDiagnosticReportsQueryResult =
  ApolloReactCommon.QueryResult<
    ListPatientDiagnosticReportsQueryResponse,
    ListPatientDiagnosticReportsQueryVariables
  >;
export type ListPatientDiagnosticReportsQueryVariables = Types.Exact<{
  dateQuery: Types.Scalars['String'];
  subjectId: Types.Scalars['String'];
}>;

export type ListPatientDiagnosticReportsQueryResponse = {
  __typename: 'Query';
  patient?: Types.Maybe<{
    __typename: 'Patient';
    id?: Types.Maybe<string>;
    diagnosticReports: {
      __typename: 'DiagnosticReportsConnection';
      edges: Array<{
        __typename: 'DiagnosticReportEdge';
        node: {
          __typename: 'DiagnosticReport';
          effectiveDateTime?: Types.Maybe<string>;
          id?: Types.Maybe<string>;
          status: Types.DiagnosticReportStatus;
          code: {
            __typename: 'CodeableConcept';
            coding?: Types.Maybe<
              Array<{
                __typename: 'Coding';
                system?: Types.Maybe<string>;
                code?: Types.Maybe<string>;
              }>
            >;
          };
          result?: Types.Maybe<
            Array<{ __typename: 'Reference'; reference?: Types.Maybe<string> }>
          >;
          extension?: Types.Maybe<
            Array<{
              __typename: 'Extension';
              url?: Types.Maybe<string>;
              valueReference?: Types.Maybe<{
                __typename: 'Reference';
                reference?: Types.Maybe<string>;
              }>;
            }>
          >;
        };
      }>;
    };
  }>;
};
